export default "__VITE_ASSET__CbYOgIAx__";